import {
  Box,
  IconButton,
  SwipeableDrawer,
  SwipeableDrawerProps,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import React, { ReactElement, ReactNode } from 'react';
import { CloseIcon } from 'components/icons/CloseIcon';
import { colorGrey } from 'customColors';

export interface DrawerProps extends SwipeableDrawerProps {
  title: string;
  onClose: () => void;
  children: ReactNode;
  width?: number | string;
  padding?: number;
}

export const Drawer = ({
  title,
  children,
  width,
  padding = 16,
  ...props
}: DrawerProps): ReactElement => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const iOS =
    typeof window !== 'undefined' &&
    window.navigator &&
    /iPad|iPhone|iPod/.test(navigator.userAgent);

  const drawerWidth = width || (isMobile ? '100%' : 480);

  return (
    <SwipeableDrawer
      anchor="right"
      disableBackdropTransition={!iOS}
      disableDiscovery={iOS}
      sx={{
        '& .MuiDrawer-paper': {
          width: drawerWidth,
          maxWidth: '100%',
        },
      }}
      {...props}
    >
      <Box p={padding} height="100vh">
        <Box flex={`0 1 ${60 - 16}px`}>
          <Box
            position="absolute"
            top={14}
            left={16}
            zIndex={100}
            style={{ cursor: 'pointer' }}
            onClick={() => props.onClose()}
          >
            <IconButton sx={{ m: 0, p: 0 }}>
              <CloseIcon strokeColor={colorGrey} />
            </IconButton>
          </Box>
          <Box
            position="absolute"
            top={18}
            left={0}
            right={0}
            textAlign="center"
          >
            <Typography
              sx={{
                fontSize: 16,
                fontFamily: 'Poppins',
                fontWeight: 600,
                color: theme => theme.palette.text.primary,
              }}
            >
              {title}
            </Typography>
          </Box>
        </Box>
        <Box mt={60 - 16} height="calc(100vh - 60px - 16px)">
          {children}
        </Box>
      </Box>
    </SwipeableDrawer>
  );
};
